import { render, staticRenderFns } from "./MediaField.vue?vue&type=template&id=40a92bb6&scoped=true"
import script from "./MediaField.vue?vue&type=script&lang=js"
export * from "./MediaField.vue?vue&type=script&lang=js"
import style0 from "./MediaField.vue?vue&type=style&index=0&id=40a92bb6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a92bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a92bb6')) {
      api.createRecord('40a92bb6', component.options)
    } else {
      api.reload('40a92bb6', component.options)
    }
    module.hot.accept("./MediaField.vue?vue&type=template&id=40a92bb6&scoped=true", function () {
      api.rerender('40a92bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/fields/MediaField.vue"
export default component.exports